export default "__VITE_ASSET__CKTbiwzT__"